import Alpine from 'alpinejs';

window.Alpine = Alpine;
Alpine.start();

import anchorScroll from './components/anchorScroll';
import scrollToUp from './components/scrollToUp';
import {initBlock} from './blocks';

const blockNames = [
    "text-with-image",
    "call-to-action",
    "cards-with-icon",
    "cards-slider",
    "testimonials",
    "faq-with-image",
    "faq",
    "wrapper",
    "text-with-pricing",
    "text-with-html",
    "gallery",
    "logotypes"
];

for (const item of blockNames) {
    initBlock(item).then((blocks) => {
    });
}

window.addEventListener('DOMContentLoaded', () => {
    anchorScroll()
    scrollToUp()
})